import { Controller } from "@hotwired/stimulus"

// Signals' chart tooltips: hovering (or focusing) any mark that carries
// data-sig-tip shows its text at once, beside the pointer - bars, dots,
// leaderboard rows and the SVG charts' circles alike. Native title tooltips
// arrive late or not at all, so the charts use this instead.
export default class extends Controller {
    connect() {
        this.bubble = document.createElement("div")
        this.bubble.className = "signal-tip-bubble"
        this.bubble.setAttribute("role", "tooltip")
        this.bubble.hidden = true
        document.body.appendChild(this.bubble)
        this.over = (event) => this.show(event)
        this.move = (event) => this.place(event.clientX, event.clientY)
        this.out = (event) => { if (!event.relatedTarget || !event.relatedTarget.closest?.("[data-sig-tip]")) this.hide() }
        this.focus = (event) => {
            const mark = event.target.closest?.("[data-sig-tip]")
            if (!mark) return
            const box = mark.getBoundingClientRect()
            this.open(mark, box.left + box.width / 2, box.top)
        }
        this.element.addEventListener("mouseover", this.over)
        this.element.addEventListener("mousemove", this.move)
        this.element.addEventListener("mouseout", this.out)
        this.element.addEventListener("focusin", this.focus)
        this.element.addEventListener("focusout", this.out)
    }

    disconnect() {
        this.element.removeEventListener("mouseover", this.over)
        this.element.removeEventListener("mousemove", this.move)
        this.element.removeEventListener("mouseout", this.out)
        this.element.removeEventListener("focusin", this.focus)
        this.element.removeEventListener("focusout", this.out)
        this.bubble?.remove()
    }

    show(event) {
        const mark = event.target.closest?.("[data-sig-tip]")
        if (!mark) return
        this.open(mark, event.clientX, event.clientY)
    }

    open(mark, x, y) {
        const text = mark.getAttribute("data-sig-tip")
        if (!text) return
        this.bubble.textContent = text
        this.bubble.hidden = false
        this.place(x, y)
    }

    // Above and right of the pointer, kept inside the window.
    place(x, y) {
        if (this.bubble.hidden) return
        const pad = 12
        const width = this.bubble.offsetWidth
        const height = this.bubble.offsetHeight
        const left = Math.min(Math.max(8, x + pad), window.innerWidth - width - 8)
        const top = y - height - pad < 8 ? y + pad + 8 : y - height - pad
        this.bubble.style.left = `${left}px`
        this.bubble.style.top = `${top}px`
    }

    hide() {
        if (this.bubble) this.bubble.hidden = true
    }
}
